import { MotionValue } from "motion/react";
import { createContext, useContext } from "react";

import { IPlaybackEvent, IPlaybackModel } from "../investigation.models";

/** Stable playback API shared by the map marker, the panel and the transport bar. */
export interface IRideInvestigationPlaybackContext {
  rideId?: number;
  model?: IPlaybackModel;
  loading: boolean;
  error: boolean;
  isOpen: boolean;
  isPlaying: boolean;
  speedMultiplier: number;
  /** Playhead time (epoch ms). A motion value so per-frame updates never re-render React. */
  playheadMs: MotionValue<number>;
  /** The most recent event crossed while playing (for "as it happens" callouts). */
  justFiredEvent?: IPlaybackEvent;
  play: () => void;
  pause: () => void;
  toggle: () => void;
  seekToMs: (ms: number) => void;
  seekToFraction: (fraction: number) => void;
  setSpeedMultiplier: (multiplier: number) => void;
  /** Rewind the playhead to the start and keep playing. */
  restart: () => void;
  /** Stop playback and rewind the playhead to the start. */
  reset: () => void;
  close: () => void;
}

export const RideInvestigationPlaybackContext =
  createContext<IRideInvestigationPlaybackContext | null>(null);

export const usePlaybackContext = (): IRideInvestigationPlaybackContext => {
  const context = useContext(RideInvestigationPlaybackContext);

  if (!context) {
    throw new Error(
      "usePlaybackContext must be used within a RideInvestigationPlaybackProvider",
    );
  }

  return context;
};
